import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {AvailableNoneNullableNumericOperators} from '@em/data-feed/util-types';
import {EmInputModule, EmSelectModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-days-value-filter',
  templateUrl: './days-value-filter.component.html',
  styleUrls: ['./days-value-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmSelectModule,
    EmInputModule,
  ],
})
export class EmDaysValueFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;
  operators = AvailableNoneNullableNumericOperators;
  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
